import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Select from "react-select";
import { Link } from "react-router-dom";
import authService from "../services/authservices";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function Policy() {
  const [showType, setShowType, showTyperef] = useState("Privacy");
  const [siteDatacomes, setSiteData] = useState("");
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    getSitedata();
  }, []);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };
  return (
    <div>
      <section>
        <Header />
      </section>
      <div className="">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-2 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-10 deposit_pad_top">
              <div className="row">
                <div className="col-lg-9">
                  {showTyperef.current == "Privacy" ? (
                    <div className="policy_main">
                      <div className="policy_top_main">
                        <span className="policy_head">
                          {t("PrivacyPolicies")}
                        </span>
                        <div className="policy_top_submain">
                          <div className="policy_state_active">
                            <span className="">{t("PrivacyPolicies")}</span>
                          </div>
                          <div
                            className="policy_state_deactive"
                            onClick={() => setShowType("Terms")}
                          >
                            <span className="">{t("Terms&Conditions")}</span>
                          </div>
                        </div>
                      </div>
                      <div className="policy_second_main">
                        <div className="policy_top_main">
                          {/* <span className="policy_esti_date">
                            Effective Date: 07 October 2025
                          </span> */}
                          <span className="Under_estidate_cont">
                            <b>{t("Binarge")}</b>
                            {t("Binargeweus")}
                          </span>
                        </div>
                        <div className="policy_second_main">
                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("INFORMATION")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("CollectInformation")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("WalletInformation")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("BlockchainInformation")}{" "}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("TransactionInformation")}{" "}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("WhenYouUseTheInterface")}
                              </span>
                            </div>
                            <div className="policy_top_main">
                              <span className="policy_esti_date">
                                {t("INFORMATIONAUTOMATICALLY")}
                              </span>
                              <div>
                                <span className="polisy_inn_content_span">
                                  {t("ExchangeInformation")}
                                </span>
                                <span className="polisy_inn_content_span">
                                  {t("AutomatedCollection")}
                                </span>

                                <span className="polisy_inn_content_span">
                                  {t("StrategyInformation")}
                                </span>
                              </div>
                            </div>
                            <div className="policy_top_main">
                              <span className="policy_esti_date">
                                {t("SHARINGANDDISCLOSURE")}
                              </span>
                              <div>
                                <span className="polisy_inn_content_span">
                                  {t("PaymentAndTransaction")}
                                </span>
                                <span className="polisy_inn_content_span">
                                  {t("InformationShared")}
                                </span>
                              </div>
                            </div>
                            <div className="policy_top_main">
                              <span className="policy_esti_date">
                                {t("CRYPTOGRAPHICHASHES")}
                              </span>
                              <div>
                                <span className="polisy_inn_content_span">
                                  {t("AgreeAndAcknowledge")}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("SOCIALNETWORKPLUGINS")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("WebsiteIncorporates")}
                              </span>
                            </div>
                          </div>

                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("USEOFSERVICES")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("UsingTheServices")}
                              </span>
                            </div>
                          </div>

                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("YOURCONSENT")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("UsingOurSite")}
                              </span>
                            </div>
                          </div>

                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("CLARIFICATIONS")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("Queries")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="policy_main">
                      <div className="policy_top_main">
                        <span className="policy_head">{t("Terms&Conditions")}</span>
                        <div className="policy_top_submain">
                          <div
                            className="policy_state_deactive"
                            onClick={() => setShowType("Privacy")}
                          >
                            <span className="">{t("PrivacyPolicies")}</span>
                          </div>
                          <div className="policy_state_active">
                            <span className="">{t("Terms&Conditions")}</span>
                          </div>
                        </div>
                      </div>
                      <div className="policy_second_main">
                        <div className="policy_top_main">
                          {/* <span className="policy_esti_date">
                            Effective Date: 07 October 2024
                          </span> */}
                          <span className="Under_estidate_cont">
                           {t("welcomeTo")}
                          </span>
                        </div>
                        <div className="policy_second_main">
                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="polisy_inn_content_span">
                                {t("Terms")}
                              </span>
                            </div>
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("NOTICE")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("Please")}
                              </span>
                            </div>
                          </div>

                          <div className="policy_second_innimp">
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("Modification")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("reserve")}{" "}
                              </span>
                            </div>
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("Eligibility")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("access")}{" "}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("further")}{" "}
                              </span>
                            </div>
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("AdditionalRights")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("followingRights")}
                              </span>
                            </div>
                          </div>

                          <div className="policy_second_innimp">
                            <span className="policy_inner_head_span">
                              {t("AssumptionOfRisk")}
                            </span>
                            <div className="policy_inner_mainhead">
                              <span className="polisy_inn_content_span">
                                {t("Interface")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("furtherUnderstand")}
                              </span>
                            </div>
                            <div className="policy_inner_mainhead">
                              <span className="policy_inner_head_span">
                                {t("EntireAgreement")}
                              </span>
                              <span className="polisy_inn_content_span">
                                {t("termsConstitute")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Policy;
